import axios from 'axios';

// axios.defaults.headers.common['ON_GPX'] = 'on GPX';

export default axios;
